// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__2sZ3O","title":"Info_title__3ucFW","selects":"Info_selects__1QZtZ","requiredAsterisk":"Info_requiredAsterisk__4U76G"};